import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GenericFilter } from 'shared';
import { UserTenantDto } from 'shared';
import { UserDto } from 'shared';
import { UserProfileForCreation } from 'shared';
import { AccountService } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { UserProfileService } from 'shared';

@Component({
    selector: 'confirm-user',
    templateUrl: './confirm-user.component.html',
    styleUrls: ['./confirm-user.component.scss'],
    standalone: false
})
export class ConfirmUserComponent implements OnInit {

  @Input('user') user!: UserDto; 
  @Input('userTenants') userTenants!: UserTenantDto[]; 
  @Input('showProfile') isCalledFromShowProfile!: boolean; 

  @Output() onChangeUser: EventEmitter<UserDto> = new EventEmitter();

  userMainForm!: UntypedFormGroup;
  baseUserTenant!: UserTenantDto;
  isConfirmed = false;
  childrenStayExpanded = false;
  expandData = true;
  userName!: string;
  userFormCreated = false;

  // userProfile!:UserProfileForCreation;


  constructor(
    public translate: TranslateService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private accountService: AccountService,
    private tenantService: TenantService,
    private userProfileService: UserProfileService,
    private router: Router
  )
   {

   }

  ngOnInit() {

    // console.log("--------> confirm-user: user = ", this.user);
    // console.log("--------> confirm-user: userTenants  = ", this.userTenants);
    console.log("--------> confirm-user called by show-profile = ", this.isCalledFromShowProfile);
    if (this.isCalledFromShowProfile) {
      this.isConfirmed = true;
      this.expandData = true;
      this.userName = this.user.first_Name + " " + this.user.last_Name;
    } else {
      this.expandData = !this.user.emailConfirmed;
      this.userName = this.user.email;
    }
    console.log("-------> confirm-user expandDate = ", this.expandData);

    console.log("---------> confirm-user userTenants = ", this.userTenants)
    //const baseUserTenant: new UserTenantDto();
    this.userTenants.forEach((ut: UserTenantDto) => {
      if (ut.tenantName == 'Basis'){
        this.baseUserTenant = ut;
      }
    });

    this.createUserMainForm();

    // this.userProfileService.getUser().subscribe({
    //   next:(userProfile: UserProfileForCreation) => {       
    //     this.userProfile = userProfile;
    //   }
    // });

  }

  createUserMainForm(){
    this.userMainForm = this.formBuilder.group({
      //userName:[(this.user.userName != this.user.email)?this.user.userName:null, Validators.required],
      // firstName:[this.normalizeString(this.user.first_Name), Validators.required],
      // lastName:[this.normalizeString(this.user.last_Name), Validators.required],
      firstName:[this.user.first_Name, Validators.required],
      lastName:[this.user.last_Name, Validators.required],
      email:[{value: this.user.email, disabled: true}],
      phoneNumber:[this.user.phoneNumber, [Validators.maxLength(50), Validators.pattern(/^[0-9 +\-()./]*$/)]],
    });
    this.userFormCreated = true;
  }

  // createUserTenantForm(){
  //   this.userMainForm = this.formBuilder.group({
  //     userName:[null, Validators.required],
  //     firstName:[this.user.firstName, Validators.required],
  //     lastName:[this.user.lastName, Validators.required],
  //     email:[this.user.email, Validators.required],
  //     phoneNumber:[this.user.phoneNumber],
  //   });
  // }

  private normalizeString(value: string | null | undefined): string {
    console.log("------> confirm-user normalizeString value=", value ? value.normalize('NFC') : '');
    return value ? value.normalize('NFC') : '';
  }

  cancel(){
  }

  confirm(){
    if (this.userMainForm.valid) {
      var screenData = this.userMainForm.getRawValue();
      this.user.emailConfirmed = true;
      this.user.twoFactorEnabled = true;
      // this.user.userName = this.normalizeString(screenData.firstName + " " + screenData.lastName);
      this.user.userName = screenData.firstName + " " + screenData.lastName;
      this.userProfileService.currentUserName = this.user.userName;
      this.user.phoneNumber = screenData.phoneNumber;
      this.user.email = screenData.email;
      this.user.userName = screenData.email;
      // this.user.first_Name = this.normalizeString(screenData.firstName);
      // this.user.last_Name = this.normalizeString(screenData.lastName);
      this.user.first_Name = screenData.firstName;
      this.user.last_Name = screenData.lastName;

      this.expandData = false;

      console.log("------>confirmation data: ", this.user)

      this.accountService.updateUser(this.user).subscribe({
        next:(userDto:UserDto) => { 
          this.userProfileService.currentUserName = this.user.first_Name + " " + this.user.last_Name;
          //this.user = userDto;
//          this.onChangeUser.emit(this.user);
        },
        error: (error: any) => {
        }
      });

      console.log("------> confirm-user - current tenant", this.tenantService.currentTenantName)
      console.log("------> baseUserTenant: ", this.baseUserTenant)
      if (this.baseUserTenant){
        this.baseUserTenant.isConfirmed = true;
        this.tenantService.updateUserTenancy(this.baseUserTenant).subscribe({
          next:(userTenantDto:UserTenantDto) => { 
            this.baseUserTenant = userTenantDto;
            //this.onChangeTenantUser.emit(this.user);
          },
          error: (error: any) => {
          }
        });
      }

      // this.userProfile.id = this.user.id;
      // this.userProfile.fullName = this.user.firstName + " " + this.user.lastName;
      // this.userProfile.isEmailConfirmed = true;
      // this.userProfile.phoneNumber = this.user.phoneNumber;
      // this.userProfile.givenName = this.user.firstName;
      // this.userProfile.familyName = this.user.lastName;

      // this.userProfileService.updateProfileById(this.user.id, this.userProfile).subscribe({
      //   next:(data) => {
      //   },
      //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPROFILEUPADTEDERROR"]}`)
      // });    
      

    }

  }

  onChange(user: UserDto){

    console.log("------> confirm-user catch confirm-tenant-user change event: user=", user);
//    this.onChangeUser.emit(this.user);
    this.checkUserConfirmation(user);

  }

  continue(){
    this.onChangeUser.emit(this.user);
    if (this.isCalledFromShowProfile) {
      if (this.tenantService.currentTenantName == this.tenantService.SystemManagerAbbreviation) this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
      else this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
    }
  }

  checkUserConfirmation(user: UserDto){
    this.tenantService.getUserTenantz(user.id, new GenericFilter).subscribe({
      next:(tenantDtos:UserTenantDto[]) => { 
        this.userTenants = tenantDtos;
        let confirmed = true;
        this.userTenants.forEach(function (ut) {
          if (!ut.isConfirmed) {
            confirmed = false;
          }
          // if (ut.id == userTenant.id)
          // {
          //   ut.isExpanded = true;
          // }
        })
        console.log("------> confirm-user setting confirmed=", confirmed);
        this.isConfirmed = confirmed;
      },
      error: (error: any) => {
      }
    });
  }
}